import { laravelLogout } from '@/app/logout';
import { Crisp } from 'crisp-sdk-web';
import { removeImpersonationCookie } from './impersonation';
import { AxiosError } from 'axios';
import { showErrorNotification } from '@/app/components/shared/notifications';
import { getUser } from '@/app/(actions)/user/getUser';
import { urlHelper } from './urlHelper';

export const customSignOut = async ({
  withLaravelLogout,
  withRedirect,
}: {
  withLaravelLogout: boolean;
  withRedirect: boolean;
}) => {
  removeImpersonationCookie();
  if (withLaravelLogout) {
    await laravelLogout();
  }
  try {
    await getUser(); // If this doesn't fail with 401, it means the user is still logged in and we shouldn't destroy other sessions
    showErrorNotification({
      title: 'Signing out failed!',
      message: 'Please try again later! If the error persists, please contact the customer service!',
    });
  } catch (error) {
    if (!(error instanceof AxiosError) || error.response?.status !== 401) {
      showErrorNotification({
        title: 'Signing out failed!',
        message: 'Please try again! If the error persists, please contact the customer service!',
      });
      throw error;
    }
    Crisp.setTokenId();
    Crisp.session.reset();
    if (withRedirect) {
      window.location.href = urlHelper.login();
    }
  }
};
